export default __webpack_public_path__ + "static/media/maps.3e86f7e5.png";